import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable, Input} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { ProduitComponent } from '../../../../pages/produit/produit.component';
import { Produit } from '../../model/produit';
import { plainToClass } from 'class-transformer';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { isDefined } from '@angular/compiler/src/util';
import { Reconcilialtion } from '../../model/reconciliation';
import { Partenaire } from '../../model/partenaire';
import { ApiFile } from '../../model/apifile';



@Injectable()
export class ProduitService {

  defaultfournisseur: Partenaire; // variable utliser par les factures d'achat pour definir un fournisseur utiliser lorsqu'on creer un produit de ce fournisseur qui n'exitait pas
  defaultproduitCreate: Produit; // variable utliser par les factures d'achat pour recuperer un produit créer lors de la commande
  
  produits: Produit[];

  emballages: Produit[];

  etat: Produit[];

  localCommandesAchat: Produit[];
  localCommandesVente: Produit[];

  currentdetail: Produit;

  iSconnecting: boolean = false;

  dateGeneInventaire: string;

  addImageSpinner = false;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

  getProduits() {
    this.iSconnecting = true;
    return new Promise<Produit[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_PRODUITS,
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Produit[]) => {
            const produits = plainToClass(Produit, data);
            this.produits = produits;
            this.emballages = [];
            for (let i = 0; i < produits.length; i++) {

              if (produits[i].is_emballage)
              this.emballages.push(produits[i]);

            }

            resolve(produits);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }


  getEtat(from: string, to: string) {
    this.iSconnecting = true;
    return new Promise<Produit[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_ETAT(from, to),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: {date_gene: string, produits: Produit[]}) => {
          this.dateGeneInventaire = data.date_gene;
          const produits = plainToClass(Produit, data.produits);
            this.etat = produits;
            resolve(produits);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }


  getCommandes(type: string, partenaireid: any) {
    this.iSconnecting = true;
    return new Promise<Produit[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_COMMANDES_PRODUITS(type, partenaireid),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Produit[]) => {
            const produits = plainToClass(Produit, data);
            this.setLocalCommandes(type, produits);
            resolve(produits);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }

  getReconciliation(type: string) {
    this.iSconnecting = true;
    return new Promise<Reconcilialtion>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_RECONCILIATION_PRODUITS(type),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Reconcilialtion) => {
            resolve(data);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }

  saveProduit(produit: Produit) {
    this.iSconnecting = true;


    let id_fournisseurs: number[];


    if ( produit.fournisseurs !== undefined && produit.fournisseurs !== null && produit.fournisseurs.length > 0 ) {

      id_fournisseurs = [];

      for ( let i = 0; i < produit.fournisseurs.length; i++) {
        id_fournisseurs.push(produit.fournisseurs[i].id);
      }

    }

    let id_cats: number[];


    if ( produit.categories !== undefined && produit.categories !== null && produit.categories.length > 0 ) {

      id_cats = [];

      for ( let i = 0; i < produit.categories.length; i++) {
        id_cats.push(produit.categories[i].id);
      }

    }


    let id_emballage: number;

    if (produit.emballage !== null && produit.emballage !== undefined) {
      id_emballage = produit.emballage.id;
    } else {
      id_emballage = null;
    }

    const pat = {

      designation: produit.designation,
      prixDetail: produit.prix_detail,
      description: produit.description,
      categories: id_cats,
      tva: produit.tva,
      tvaAchat: produit.tva_achat,
      imagePrincipale: (produit.image_principale !== null && produit.image_principale !== undefined) ? produit.image_principale.id: null,
      sellInLigne: produit.sell_in_ligne,
      isPromo: produit.is_promo,
      prixPromo: produit.prix_promo,
      type: produit.type,
      isPublish: produit.is_publish,
      // dsfgdg: 'zgfeg',

    };


    if (produit.id !== 0) {

      this.iSconnecting = true;

      return new Promise<Produit>(resolve => {
        this.http.patch(this.apiEndpoints.GET_URL_PUT_PRODUIT(produit.id), pat,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Produit) => {

              this.getProduits();
              resolve(data);
              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }else {

      return new Promise<Produit>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_POST_PRODUIT, pat,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Produit) => {

              this.getProduits();
              resolve(data);
              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }



  }

  deleteProduit(produit: Produit) {
    this.iSconnecting = true;
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_PRODUIT(produit.id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            this.getProduits();
            resolve(data);
            this.iSconnecting = false;

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });


  }

  setLocalCommandes(type: string, produits: Produit[]) {

    if (type === 'vente')
    this.localCommandesVente = produits ;

    if (type === 'achat')
    this.localCommandesAchat = produits;

  }

  getLocalCommandes(type: string) {

    if (type === 'vente')
    return this.localCommandesVente;

    if (type === 'achat')
    return this.localCommandesAchat;

  }


  addImage(idprod: number, images: File[]) {

    this.addImageSpinner = true;

    const formData: FormData = new FormData();

    for(let i=0; i < images.length; i++) {
      formData.append( 'filesdata[]', images[i]);
    }


    /* const httpOptions = {
      headers: new HttpHeaders({
      'X-Auth-Token': this.apiUtils.CURRENT_ACCESS_TOKEN,
      'X-Tenant': this.apiUtils.TENANTDB,
      }).delete('Content-Type'),
    }; */

    return new Promise<ApiFile[]>(resolve => {
      this.http.post(this.apiEndpoints.URL_PRODUIT_ADD_IMAGE(idprod), formData,
      {headers: this.apiUtils.BASIC_API_REQUEST_HEADER().delete('Content-Type')})
      .subscribe((data: ApiFile[]) => {

            resolve(data);

            this.addImageSpinner = false;

          },
          err => {

            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.addImageSpinner  = false;

      });

    });

  }


  deleteImage(id: number, image: number) {
    
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.URL_PRODUIT_REMOVE_IMAGE(id, image),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            resolve(data);

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
          });
    });


  }


  addFichier(idprod: number, fichier: File, @Input() spinner: boolean) {

    this.addImageSpinner = true;

    const formData: FormData = new FormData();

    formData.append( 'filedata', fichier);

    /* const httpOptions = {
      headers: new HttpHeaders({
      'X-Auth-Token': this.apiUtils.CURRENT_ACCESS_TOKEN,
      'X-Tenant': this.apiUtils.TENANTDB,
      }).delete('Content-Type'),
    }; */

    return new Promise<ApiFile>(resolve => {
      this.http.post(this.apiEndpoints.URL_PRODUIT_ADD_FICHIER(idprod), formData,
      {headers: this.apiUtils.BASIC_API_REQUEST_HEADER().delete('Content-Type')})
      .subscribe((data: ApiFile) => {

            resolve(data);

            this.addImageSpinner = false;

          },
          err => {

            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.addImageSpinner  = false;

      });

    });

  }



  deleteFichier(id: number, fichier: number) {
    
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.URL_PRODUIT_REMOVE_FICHIER(id, fichier),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            resolve(data);

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
          });
    });

  }


}
